import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 6.8.",
  "description": "",
  "published": "2011-08-07T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-6-8/swizec/2094"],
  "categories": "Airbnb, CouchSurfing, Learning, Personal, San Francisco, Starbucks",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/4101129542_d3e9ae80f4_m2.jpg",
        "alt": "San Francisco by Night: Mission Street",
        "title": "San Francisco by Night: Mission Street"
      }}></img></p>
    <p>{`Let me break your `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Suspension_of_disbelief",
        "title": "Suspension of disbelief"
      }}>{`suspension of disbelief`}</a>{` and admit that I am not writing this "today" ... well it is still today by my standards because "tomorrow" starts at 6am and it's only 5am right now ... but `}<a parentName="p" {...{
        "href": "http://wordpress.org",
        "title": "WordPress"
      }}>{`Wordpress`}</a>{` is going to disagree with my definition and claim I have posted this tomorrow.`}</p>
    <p>{`But despite this small glitch in how the calendar is arbitrarily constructed, I did manage to learn two things today.`}</p>
    <p>{`The first and most important is that trying to book somewhere to stay for a single night on the same day you plan on showing up just doesn't work. Now I don't have enough data points to know exactly and for certain that it doesn't work, but finding such a place in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.7793,-122.4192&spn=0.1,0.1&q=37.7793,-122.4192%20(San%20Francisco)&t=h",
        "title": "San Francisco"
      }}>{`San Francisco`}</a>{` at what I'm told is the height of the tourist season ... well it doesn't work. I tried to find hostels, but all online things said nobody had any vacancies. I also tried `}<a parentName="p" {...{
        "href": "http://www.airbnb.com/",
        "title": "Airbnb"
      }}>{`Airbnb`}</a>{` and didn't even get a response ... tried `}<a parentName="p" {...{
        "href": "http://www.couchsurfing.org/",
        "title": "CouchSurfing"
      }}>{`couch surfing`}</a>{` and also didn't get a response.`}</p>
    <p>{`Hell, I even tried to beg the twitters for a couch to crash on for the night and there were no takers. Nobody wants to host for a guest that's coming at 4am and staying until about 8am ... possibly drunk out of his mind ...`}</p>
    <p>{`What was the other thing that I learned ... I know it was something useful, but I can't think of it for the life of me. So I'm going to go with having learnt that there is a `}<a parentName="p" {...{
        "href": "http://Starbucks.com",
        "title": "Starbucks"
      }}>{`Starbucks`}</a>{` open all night in San Francisco and this means I have somewhere to "stay" until the trains start running again at 8am.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-learned-two-things-today-2-8/swizec/2059"
        }}>{`I learned two things today 2.8.`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.sfgate.com/cgi-bin/article.cgi?f=/c/a/2011/08/06/EDJM1KIINF.DTL"
        }}>{`Tourists return to San Francisco`}</a>{` (sfgate.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=52252ce6-aede-483b-9135-7208b9b338bc",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      